const interlocks = {
  interlocks: 'Sas de sécurité',
  search: 'Rechercher un sas',
  add_interlocks: 'Nouveau sas de sécurité',
  schedule: 'Horaire',
  edit: 'Modifier',
  delete: 'Effacer',
  add_group: 'Nouveau groupe de sas',
  doors: 'Portes',
  save: 'Sauvegarder',
  add_door: 'Ajouter des portes',
  controller: 'Contrôleur',
  side: 'côté',
  group: 'Groupe de sas',
  actions: 'Actions',
  door_name: 'Nom de la porte',
  search_door_by_name: 'Rechercher une porte par nom',
  side_a: 'Côté A',
  side_b: 'Côté B',
  add: 'Ajouter',
  add_selected: 'Ajouter sélection',
  selected: 'Sélectionné',
  remove: 'Retirer',
  edit_group: 'Modifier le groupe de sas',
  delete_interlock_confirmation:
    'Êtes-vous sûr de vouloir supprimer ce groupe de sas?',
  cant_be_deleted: 'Ce sas ne peut pas être supprimé',
  deleted_successfully: 'Sas de sécurité supprimé avec succès',
  updated_successfully: 'Sas de sécurité mis à jour avec succès',
  created_successfully: 'Sas de sécurité créé avec succès',
};

export default interlocks;
